<template>
  <div class="cargo_ship">
    <div class="tab">
      <div 
        v-for="item in tab.titles"
        :key="item.key"
        class="tab_item"
        :class="{ 'tab_item-active': activeBody == item.key }"
        @click="changeActiveBody(item.key)"
      >
        {{ item.tabName }}
      </div>
    </div>

    <div class="body">
      <div 
        v-for="item in tab.bodies"
        :key="item.key"
        class="body_item"
        :class="{ 'body_item-active': activeBody == item.key }"
      >
        <CastomGraphic
            :received-data="item.data"
            :graph-type="graphType"
            :index-axis="indexAxis"
            :id="('line-' + item.key + id)"
            :aspect-ratio="2"
            :data-labels="dataLabels"
            :maintain-aspect-ratio="true"
            :stacked="stacked"
        />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'CargoShip',
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },
  props: {
    receivedData: {
      type: [Array, Object],
      required: true
    },
    dataLabels: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    },
    stacked: {
      type: Boolean,
      default: true
    },
    indexAxis: {
      type: String,
      default: 'x'
    },
    graphType: {
      type: String,
      default: 'line'
    }
  },
  data () {
    return {
      activeBody: null,
    }
  },
  mounted () {
    this.showBody()
  },
  computed: {
    tab () {
      let titles = []
      let bodies = []

      this.receivedData.forEach((item, index) => {
        titles.push({
          tabName: item.sub_title,
          key: index
        })

        bodies.push({
          data: item,
          key: index
        })
      })

      return {
        titles: titles,
        bodies: bodies
      }
    },
  },

  methods: {
    changeActiveBody (value) {
      this.activeBody = value
    },

    showBody () {
      let key = Object.keys(this.receivedData)[0]
      this.activeBody = key
    },
  }
}
</script>
<style lang="scss" scoped>
  .body {
    &_item {
      display: none;
      &-active {
        display: block;
      }
    }
  }

  .tab {
    display: flex;

    &_item {
      padding: 10px 20px;
      background-color: #e5e5e5;
      cursor: pointer;

      &-active {
        box-sizing: border-box;
        border-top: 5px solid #e5e5e5;
        background-color: #fff;
      }
    }
  }
</style>